export enum ButtonSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}
